import { observer } from "mobx-react-lite";

import { trackAgentOverlayEntryClick } from "@/pages/agent/analytics/use-agent-overlay-analytics";
import { AgentOverlayEntryButtonView } from "@/pages/agent/components/agent-overlay-entry-button-view";
import {
  AGENT_INTENT_MODEL_V2_FEATURE_FLAG,
  resolveAgentOverlayEntryCopy,
} from "@/pages/agent/components/agent-overlay-entry.constants";
import { useAppStore } from "@/store";

export const AgentOverlayEntryButton = observer(({ isNarrow }: { isNarrow: boolean }) => {
  const { store } = useAppStore();

  if (!store.agentOverlay.isEntryPointEnabled) {
    return null;
  }

  const taskProjectTrackingIsEnabled = store.agentOverlay.isTaskProjectTrackingEnabled;
  const supportsGoals =
    store.spaceAccountFeatureFlags.getFlagStatus(AGENT_INTENT_MODEL_V2_FEATURE_FLAG) === true;
  const goalTrackingIsEnabled = supportsGoals && store.agentOverlay.isFeatureEnabled;
  const shouldAdvertiseGoals = taskProjectTrackingIsEnabled
    ? goalTrackingIsEnabled
    : supportsGoals;
  const entryCopy = resolveAgentOverlayEntryCopy(shouldAdvertiseGoals);

  return (
    <AgentOverlayEntryButtonView
      isNarrow={isNarrow}
      label={entryCopy.label}
      accessibleLabel={
        taskProjectTrackingIsEnabled
          ? entryCopy.openAccessibleLabel
          : entryCopy.upsellAccessibleLabel
      }
      onOpenConnectedWork={() => {
        trackAgentOverlayEntryClick({
          entryPoint: "top_bar",
          isSummaryLoaded: false,
          taskCount: 0,
          projectCount: 0,
        });

        if (taskProjectTrackingIsEnabled) {
          store.agentOverlay.openTasks();
          return;
        }

        store.subscriptions.openProactiveUpsell({
          title: entryCopy.upsellTitle,
        });
      }}
    />
  );
});
